import { memo, useState } from 'react'
import { PositionNavButtons } from '../postionsWidget'
import type { Position } from '../../proto/generated/position'
import PositionsSidebarHeader from './PositionsSidebarHeader'
import PositionsTableScrollArea from '../positionsTable/PositionsTableScrollArea'

export type PositionsSidebarWidgetProps = {
    positions: Position[]
}

const PositionsSidebarWidget: React.FC<PositionsSidebarWidgetProps> = ({ positions }) => {
    const [positionTableViewType, setPositionTableViewType] = useState(PositionNavButtons.PNL)

    return (
        <>
            <PositionsSidebarHeader
                positions={positions}
                viewType={positionTableViewType}
                onViewTypeChange={setPositionTableViewType}
            />
            <PositionsTableScrollArea
                positions={positions}
                showGreeks={positionTableViewType === PositionNavButtons.GREEKS}
            />
        </>
    )
}

export default memo(
    PositionsSidebarWidget,
    (prev, next) => prev.positions === next.positions
)
